// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"_2BRBI","mobileOnly":"_2FH7P"};